// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1rqyS","row":"styles_row__3K6so"};